<template>
  <div class="password-login">
    <form @submit.prevent>
      <div class="_item">
        <div class="_label">
          {{ $t('general.email') }}
        </div>
        <m-text-field
          v-model:value="email"
          auto-focus
          autocomplete="username"
          :placeholder="$t('loginForm.enterEmail')"
          @keydown.enter="submit"
        >
          <template #prefix>
            <m-icon
              type="mail"
              :color="$colors.grey.lighten2"
            />
          </template>
        </m-text-field>
        <div
          v-if="errorMessage !== ''"
          class="_error-msg"
        >
          {{ errorMessage }}
        </div>
      </div>
      <div class="_item">
        <div class="_label">
          {{ $t('general.password') }}
        </div>
        <m-input-password
          v-model:value="password"
          autocomplete="current-password"
          :placeholder="$t('loginForm.enterPassword')"
          @keydown.enter="submit"
        />
      </div>
      <div class="_action">
        <m-btn
          :loading="loading"
          color="black"
          :button-style="{ width: '100%' }"
          :style="{ width: '100%' }"
          @click.prevent="submit"
        >
          {{ $t('login.callToAction') }}
        </m-btn>
      </div>
    </form>
    <div class="_links">
      <div class="_top">
        <m-link
          :to="forgetPasswordLink"
          underlined
          inherit-color
        >
          {{ $t('loginForm.passwordForget') }}
        </m-link>
      </div>
      <div
        v-if="!hideRegisterLink"
        class="_bottom"
      >
        <div>
          {{ $t('login.noAccount') }}
          <m-link
            :to="register"
            inherit-color
            underlined
          >
            {{ $t('login.register') }}
          </m-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { emailRegex } from 'shared/lib/email-regex';
import { routeName } from 'shared/constants.json';

export default {
  name: 'PasswordLogin',
  props: {
    loading: {
      type: Boolean,
      required: true,
    },
    hideRegisterLink: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['submit'],
  data() {
    return {
      email: '',
      password: '',
      routeName,
      submitted: false,
    };
  },
  computed: {
    errorMessage() {
      if (this.email === '' || !this.submitted) {
        return '';
      }

      const reg = new RegExp(emailRegex());
      if (reg.test(this.email)) {
        return '';
      }

      return this.$t('loginForm.notAValidEmail');
    },
    forgetPasswordLink() {
      return {
        name: routeName.forgetPassword,
        query: { email: this.email },
      };
    },
    register() {
      return {
        name: routeName.signUp,
        query: { email: this.email },
      };
    },
  },
  methods: {
    submit() {
      this.submitted = true;
      if (this.errorMessage !== '') {
        return;
      }
      this.$emit('submit', { email: this.email, password: this.password });
    },
  },
};
</script>

<style scoped lang="scss" type="text/scss">
  .password-login {
    ._links {
      color: $font-color-secondary;

      ._top {
        font-size: $font-size-3;
        margin-top: 2rem;
      }

      ._bottom {
        text-align: center;
        font-size: $font-size-4;
        margin-top: 3rem;
        display: flex;
        justify-content: space-between;
      }
    }

    ._item {
      margin-bottom: 1rem;

      ._label {
        font-size: $font-size-3;
        color: $font-color-secondary;
      }

      ._error-msg {
        margin-top: .4rem;
        color: $error-color;
      }
    }
  }
</style>
